import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TabMenuModule } from 'primeng/tabmenu';
import { MenuItem } from 'primeng/api';
import { TreeTableModule } from 'primeng/treetable';
import { NgForOf, NgIf } from '@angular/common';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { SidebarService } from '../../../services/menu/sidebar.service';

@Component({
  selector: 'app-account',
  standalone: true,
  imports: [RouterOutlet, TabMenuModule, TreeTableModule, NgForOf, NgIf],
  templateUrl: './account.component.html',
  styleUrl: './account.component.scss',
})
export class AccountComponent implements OnInit {
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-screen',
    icon: 'fas fa-user',
    headerText: 'Account',
  };

  constructor(private sidebarService: SidebarService) {}

  items: MenuItem[] | undefined;
  activeItem: MenuItem | undefined;

  /**
   * Initializes component properties and configurations upon component creation.
   * Sets up navigation items with associated labels, icons, and router links.
   * Configures the active navigation item and initializes sidebar configuration with a slight delay.
   *
   * @return {void} This method does not return any value.
   */
  ngOnInit(): void {
    this.items = [
      {
        label: 'Tools',
        icon: 'fas fa-screwdriver-wrench',
        routerLink: [{ outlets: { tab: 'tool-access' } }],
      },
      {
        label: 'Indikatoren',
        icon: 'fas fa-folder-tree',
        routerLink: [{ outlets: { tab: 'indikator-access' } }],
      },
      {
        label: 'Räume',
        icon: 'fa-regular fa-map',
        routerLink: [{ outlets: { tab: 'raum-access' } }],
      },
      {
        label: 'Standorte',
        icon: 'fas fa-location-dot',
        routerLink: [{ outlets: { tab: 'poi-access' } }],
      },
      {
        label: 'Ansichten',
        icon: 'fas fa-note-sticky',
        routerLink: [{ outlets: { tab: 'lesezeichen-access' } }],
      },
    ];
    this.activeItem = this.items[0];

    setTimeout(() => {
      this.sidebarService.setConfiguration(this.sidebarConfig);
    }, 10);
  }
}
